import React,{useEffect,useState} from 'react';
import {appGetUrlPath}  from '../function_lib/common_lib';
import male_pic from '../assets/images/def_male_pic.png';
import female_pic from '../assets/images/def_female_pic.png';

import './comp_biodata_template8.css'

const Comp_Biodata_Template8=(props)=>{
   
    useEffect(()=>{
    //   alert(JSON.stringify(props.myProfileData));
    },[props.myProfileData])

    return(
        <div class="container11 khandelwal-biodata8">
            {props.myProfileData.length>0?
        <div class="profile-card">
            <div class="profile-header position-relative">
                <div class="row align-items-center">
                    <div class="col-md-4 text-center text-md-start mb-4 mb-md-0 image-box">
                        {props.myProfileData[0]["pro_pic"]===""?
                        <>{props.myProfileData[0]["gender"].trim().toLowerCase()==="male"?<img src={male_pic} class="profile-img"/>
                    :<img src={female_pic} class="profile-img"/>}
                        </>
                        :
                        <img src={appGetUrlPath()+props.myProfileData[0]["pro_pic"]} class="profile-img" />
                        }
                        
                    </div>
                    <div class="col-md-8">
                        <h3 class="profile-name mb-4 white">{props.myProfileData[0]["mem_name"]}</h3>
                        <div class="row contact-box">
                            <div class="col-lg-6 col-sm-12 mb-2 mb-md-0">
                                <div class="d-flex align-items-center">
                                    <span class="me-2">📧</span>
                                    <span>{props.myProfileData[0]["email_id"]}</span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-12">
                                <div class="d-flex align-items-center">
                                    <span class="me-2">📱</span>
                                    <span>+91 {props.myProfileData[0]["contact_no"]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row border-bottom-res">
                <div class="col-lg-6 col-sm-12">
                    <div class="detail-section">
                        <h3 class="section-title">PERSONAL DETAILS</h3>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Date Of Birth:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["fmt_dob"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Birth Time:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["fmt_time"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Height:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["height"]+" cm"}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Skin Colour</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["skin_color"]}</div>
                        </div>
                      
                        <div class="row mb-2">
                            <div class="col-5 info-label">Religion:</div>
                            <div class="col-7 info-value">Hindu</div>
                        </div>
                        
                        <div class="row mb-2">
                            <div class="col-5 info-label">Native Place:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["birth_place"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">District:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["birth_place"]}</div>
                        </div>
                      
                    </div>
                    
                  
                    
                    
                </div>
                
                <div class="col-lg-6 col-sm-12">
                    <div class="detail-section">
                        <h3 class="section-title">FAMILY DETAILS</h3>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Father's Name:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["father_nm"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Father's Job:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["father_occup"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Mobile No:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["father_contact"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Mother's Name:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["mother_name"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Mother's Job:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["mother_occup"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Siblings:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["brother_status"]+", "+props.myProfileData[0]["sister_status"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Self Goutra:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["self_goutra"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Mama's Goutra:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["mama_goutra"]}</div>
                        </div>
                    </div>
                </div>


            </div>
            
{/* second section row */}
<div class="row border-bottom-res">
    {/* part 1 */}
<div class="col-lg-6 col-sm-12">
    
  <div class="detail-section">
                        <h3 class="section-title">EDUCATION</h3>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Qualification:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["max_qualification"]} / {props.myProfileData[0]["max_qualification_det"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Profession:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["occupation"]}</div>
                        </div>
                     
                    </div>
    </div>

    {/* end of part1 */}

   {/* part 2 */}
<div class="col-lg-6 col-sm-12">
    
  <div class="detail-section professional-details">
                        <h3 class="section-title">PROFESSIONAL DETAILS</h3>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Occupation:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["occupation"]}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Family Income:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["family_anum"]} LPA</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 info-label">Self Income:</div>
                            <div class="col-7 info-value">{props.myProfileData[0]["self_anum"]} LPA</div>
                        </div>
                     
                    </div>
    </div>

    {/* end of part1 */} 

</div>
{/* end of second section row */}
        </div>:''}
    </div>
    );
}
export default Comp_Biodata_Template8